import useAuthenticatedQuery from "./useAuthenticatedQuery";

const useGetStatisticData = () => {
  // Fetching multiple data sets
  const ptwPerSiteQuery = useAuthenticatedQuery(
    ["ptwpersite"],
    "/api/v1/stats/work-permits/count/per-site"
  );
  const ptwPerWorkflowQuery = useAuthenticatedQuery(
    ["ptwperworkflow"],
    "/api/v1/stats/work-permits/count/per-workflow"
  );
  const ptwMonthlyTrendQuery = useAuthenticatedQuery(
    ["monthlytrend"],
    "/api/v1/stats/work-permits/monthly-trend"
  );
  const ptwPerPerformerQuery = useAuthenticatedQuery(
    ["ptwperperformer"],
    "/api/v1/stats/work-permits/count/per-performer"
  );
  const ptwPerAuthorQuery = useAuthenticatedQuery(
    ["ptwperauthor"],
    "/api/v1/stats/work-permits/count/per-author"
  );

  // Destructuring
  const {
    data: ptwPerSite,
    isLoading: ptwPerSiteLoading,
    error: errorPtwPerSite,
    refetch: refetchPtwPerSite,
  } = ptwPerSiteQuery || {};

  const {
    data: ptwPerWorkflow,
    isLoading: ptwPerWorkflowLoading,
    error: errorPtwPerWorkflow,
    refetch: refetchPtwPerWorkflow,
  } = ptwPerWorkflowQuery || {};

  const {
    data: ptwMonthlyTrend,
    isLoading: ptwMonthlyTrendLoading,
    error: errorPtwMonthlyTrend,
    refetch: refetchPtwMonthlyTrend,
  } = ptwMonthlyTrendQuery || {};

  const {
    data: ptwPerPerformer,
    isLoading: ptwPerPerformerLoading,
    error: errorPtwPerPerformer,
    refetch: refetchPtwPerPerformer,
  } = ptwPerPerformerQuery || {};

  const {
    data: ptwPerAuthor,
    isLoading: ptwPerAuthorLoading,
    error: errorPtwPerAuthor,
    refetch: refetchPtwPerAuthor,
  } = ptwPerAuthorQuery || {};

  // Single flags
  const isLoading =
    ptwPerSiteLoading ||
    ptwPerWorkflowLoading ||
    ptwMonthlyTrendLoading ||
    ptwPerPerformerLoading ||
    ptwPerAuthorLoading;

  const error =
    errorPtwPerSite ||
    errorPtwPerWorkflow ||
    errorPtwMonthlyTrend ||
    errorPtwPerPerformer ||
    errorPtwPerAuthor;

  // Single refetchAll
  const refetchAll = async () => {
    await Promise.all([
      refetchPtwPerSite(),
      refetchPtwPerWorkflow(),
      refetchPtwMonthlyTrend(),
      refetchPtwPerPerformer(),
      refetchPtwPerAuthor(),
    ]);
  };

  return {
    // Counts and Totals
    counts: {
      ptwPerSite,
      ptwPerWorkflow,
      ptwPerPerformer,
      ptwPerAuthor,
    },

    // Trend Data
    trends: {
      ptwMonthlyTrend,
    },

    // Status helpers
    isLoading,
    error,

    // Refetchers
    refetch: {
      refetchPtwPerSite,
      refetchPtwPerWorkflow,
      refetchPtwMonthlyTrend,
      refetchPtwPerPerformer,
      refetchPtwPerAuthor,
      refetchAll,
    },
  };
};

export default useGetStatisticData;
